import { zergApi } from "@/service/zerg";

const prefix = "/rrhh/adelanto-sueldo";

class AdelantoSueldoService {


    async index(params) {
        try {
            const data = await zergApi.post(`${prefix}/index`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async store(params) {
        try {
            const data = await zergApi.post(`${prefix}/store`, params, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return data;

        } catch (error) {
            throw error;
        }
    }

    async getDiscountFractionsById(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-discount-fractions-by-id`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async show(params) {
        try {
            const data = await zergApi.post(`${prefix}/show`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async update(params) {
        try {
            const data = await zergApi.post(`${prefix}/update`, params, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async destroy(params) {
        try {
            const data = await zergApi.post(`${prefix}/destroy`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }


    async approve(params) {
        try {
            const data = await zergApi.post(`${prefix}/approve`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async deleteSustento(params) {
        try {
            const data = await zergApi.post(`${prefix}/delete-sustento`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async firmar(params) {
        try {
            const data = await zergApi.post(`${prefix}/firmar`, params, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async exportToExcel(params) {
        try {
            const data = await zergApi.post(`${prefix}/excel`, params, {
                responseType: "blob",
            });
            return data;
        } catch (error) {
            throw error;
        }
    }
    // async getDiscountTypes(params) {
    //     try {
    //         const data = await zergApi.post("/rrhh/discounts/get-discount-types", params);
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    // async getEmployeeByArea(params) {
    //     try {
    //         const data = await zergApi.post("/rrhh/discounts/get-employee-by-area", params);
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    // async getDiscount_tracking(params) {
    //     try {
    //         const data = await zergApi.post("/rrhh/discounts/get-discount-tracking", params);
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }


    // async getPendingDiscountsSum(params) {
    //     try {
    //         const data = await zergApi.post("/rrhh/discounts/get-pending-discounts-sum", params);
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }
}

export default new AdelantoSueldoService();